<template>
    <SbsTooltip
        position="top"
        :disabled="opened"
        content="Скорость воспроизведения">
        <SbsSelect
            v-model="selectedValue"
            v-model:opened="opened"
            selectListGroupClass="AudioPlaybackRateControls__List"
            :popupProps="{
                maxWidth: '164',
                position: 'top',
                offset: 20,
            }"
            :items="rateList"
            :bordered="false">
            <template #prepend>
                <span class="AudioPlaybackRateControls__Title">СКОРОСТЬ</span>
            </template>
            <template #default>
                <div
                    class="AudioPlaybackRateControls"
                    @click.stop="toggleOpen">
                    {{ SelectButtonText }}
                </div>
            </template>
        </SbsSelect>
    </SbsTooltip>
</template>

<script>
import { PLAYBACK_RATE } from '../constants/index.js';

export default {
    name: 'AudioPlaybackRateControls',
    emits: ['changePlaybackRate'],
    data() {
        return {
            opened: false,
            selectedValue: String(this.playbackRate) ?? '1',
        };
    },
    computed: {
        rateList() {
            return PLAYBACK_RATE;
        },
        SelectButtonText() {
            return `${this.selectedValue}X`;
        },
    },
    methods: {
        toggleOpen() {
            this.opened = !this.opened;
        },
    },
    props: {
        playbackRate: {
            type: Number,
            default: 1,
        },
    },
    watch: {
        selectedValue(newVal) {
            this.$emit('changePlaybackRate', parseFloat(newVal));
        },
    },
};
</script>

<style lang="scss">
.AudioPlaybackRateControls {
    color: $gray-deep;
    font-weight: 500;
    cursor: pointer;

    &:hover,
    :active {
        color: $gray;
    }
}

.AudioPlaybackRateControls__Title {
    padding: 5px 10px 5px 15px;
    color: $gray-deep;

    @include typo-subsecondary-demi;
}

.AudioPlaybackRateControls__List {
    padding: 0 10px;

    & .sbs-select-list__content {
        gap: 2px;
    }

    & .sbs-select__list-item {
        border-radius: 5px;
    }

    & .sbs-select__list-item-label {
        padding-right: 10px;
        padding-left: 0;
        border-radius: 5px;

        &:hover {
            background-color: $lightblue;
        }
    }

    & .sbs-select__list-item.selected {
        background-color: $lightblue;
    }
}
</style>
